<script>
  import { SIGN_UP_STEPS } from '@/helpers/enums';

  export default {
    name: 'SignUpOTPVerification',

    props: {
      phone: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      otp: '',
    }),

    computed: {
      formattedPhone() {
        const countryCode = this.phone.countryCode;
        const number = this.phone.number.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');

        return `${countryCode} ${number}`;
      },
    },

    methods: {
      goToPhone() {
        this.$store.dispatch('changeSignupStep', SIGN_UP_STEPS.VERIFY_PHONE);
      },
      async resendCode() {
        await this.$store.dispatch('sendVerification', {
          phoneNumber: this.phone.countryCode + this.phone.number,
          ignoreRedirect: true,
        });
      },
      async verifyCode() {
        await this.$store.dispatch('verifyPhoneNumber', {
          verificationKey: this.otp,
          phoneNumber: this.phone.countryCode + this.phone.number,
        });
      },
    },
  };
</script>

<template>
  <div class="d-flex flex-column align-center mt-6 gap">
    <span class="white--text font-weight-600 font-size-16" data-test-id="otp-verification-text">OTP Verification</span>
    <span class="white--text mt-4">
      One Time Password (OTP) has been sent via SMS to:
      <span class="font-weight-600">{{ formattedPhone }}</span>
    </span>

    <div class="my-6">
      <span class="label required white--text">Verification Code</span>
      <v-otp-input v-model="otp" class="otp-input" :length="6" dark plain type="number" />
    </div>

    <div class="buttons-container w-full">
      <action-button>
        <template #action="{ loading, clickHandler }">
          <v-btn
            class="golden-outlined w-full"
            data-test-id="resend-button"
            :loading="loading"
            @click="clickHandler(resendCode)"
          >
            Resend
          </v-btn>
        </template>
      </action-button>
      <action-button>
        <template #action="{ loading, clickHandler }">
          <v-btn
            class="golden-button w-full"
            data-test-id="verify-my-phone-button"
            :loading="loading"
            @click="clickHandler(verifyCode)"
          >
            Verify My Phone
          </v-btn>
        </template>
      </action-button>
    </div>

    <span class="white--text mt-6 font-size-16">
      Wrong number?
      <span class="text-underline" data-test-id="change-number-button" @click="goToPhone()">Change number here</span>
    </span>
  </div>
</template>

<style scoped lang="scss">
  @import '@/scss/mixins.scss';
  @include outlined-input;

  .buttons-container {
    gap: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .otp-input {
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    padding: 6px 16px;
    height: 44px;

    &::v-deep {
      .v-input {
        padding: 0 4px;
      }

      .v-input__control .v-input__slot {
        min-height: 24px !important;
        background: transparent !important;

        input {
          font-weight: 500;
        }
      }
    }
  }

  .text-underline {
    text-decoration: underline;
    cursor: pointer;
    color: var(--v-gold-base);
  }
</style>
